export enum CertificationCodeStatus {
  EXPIRED_CERTIFICATION_CODE = "EXPIRED_CERTIFICATION_CODE",
  INVALID_CERTIFICATION_CODE = "INVALID_CERTIFICATION_CODE",
  NO_CERTIFICATION_REQUEST = "NO_CERTIFICATION_REQUEST",
  MANDATORY_PARAM_ERR = "MANDATORY_PARAM_ERR",
}
